import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/minicity_logo.png';
const _withScopeId = n => (_pushScopeId("data-v-70c27335"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "container p-4" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("img", {
        class: "headerLogo",
        src: _imports_0
    })
], -1));
const _hoisted_3 = {
    key: 1,
    class: "notification bulmaNotification is-danger m-6"
};
import { useAsync } from "@/composables/useAsync";
import { CONFIG } from "@/core/config";
import { onMounted } from "vue";
import { apiPartnerOnboarding } from "../api";
import PartnerOnboardingForm from "../components/PartnerOnboardingForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerOnboarding',
    props: {
        inviteCode: {}
    },
    setup(__props) {
        const props = __props;
        const invite = useAsync();
        onMounted(() => {
            invite.fetch(apiPartnerOnboarding.validatePartnerInviteToken("minicity", props.inviteCode));
        });
        return (_ctx, _cache) => {
            const _component_LoadingPage = _resolveComponent("LoadingPage");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                (_unref(invite).status == 'loading')
                    ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
                    : (_unref(invite).status == 'error')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createTextVNode(" There was a problem with your invite link. Please contact "),
                            _createElementVNode("strong", null, _toDisplayString(_unref(CONFIG).helpEmail), 1)
                        ]))
                        : (_unref(invite).status == 'ready')
                            ? (_openBlock(), _createBlock(PartnerOnboardingForm, {
                                key: 2,
                                class: "form",
                                invite: _unref(invite).data
                            }, null, 8, ["invite"]))
                            : _createCommentVNode("", true)
            ]));
        };
    }
});
